import api from './api';

import { iniciarRequisicao, logout } from "../helpers";
import { STATUS_HTTP } from "./statusHTTP";

export const updateRelacionamentosMPPA = async (params) => {
  let url = '/compra/analise-compra-materia-prima/update-relacionamentos-materia-prima-produto-acabado';

  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados;
  }

  logout();
}

export const getProdutosCategoria = async (id) => {
  let url = `/compra/analise-compra-materia-prima/get-produtos-categoria/${id}`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.get(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.dados;
  }

  logout();
}

export const deletarCategoria = async (id) => {
  let url = `/compra/analise-compra-materia-prima/deletar/${id}`;

  const config = {
    headers: iniciarRequisicao()
  };

  const {data, status} = await api.delete(url, config).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return ;
  }

  logout();
}

class CategoriaCompraMateriaPrimaAPI {
  async getMateriaPrima(headers, params) {
    const response = await api.get("/compra/analise-compra-materia-prima/get-materia-prima", {
      params,
      headers
    });
    return response;
  }

  async getPAFromMP(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compra/analise-compra-materia-prima/get-produto-acabado-de-materia-prima',
      headers,
      data: params
    });

    return response;
  }

  async getMPRelacionadaFromPA(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compra/analise-compra-materia-prima/get-materia-prima-relacionada-produto-acabado',
      headers,
      data: params
    });

    return response;
  }

  async storeRelacionamentosMPPA(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compra/analise-compra-materia-prima/store-relacionamentos-materia-prima-produto-acabado',
      headers,
      data: params
    });

    return response;
  }

  async buscarItensCategoriaExpand(headers, params) {
    const response = await api({
      method: 'post',
      url: "/compra/analise-compra-materia-prima/buscar-itens-categoria-expand",
      headers,
      data: params
    });

    return response;
  }

  async buscarCategoriaCompra(headers, params = {}) {
    const response = await api({
      method: 'post',
      url: "/compra/analise-compra-materia-prima/buscar-categoria-compra",
      headers,
      data: params
    });

    return response;
  }
}

export default new CategoriaCompraMateriaPrimaAPI();
